<template>
  <el-card style="width: 32%;">
    <div ref="statistics" style="height: 350px;"></div>
  </el-card>
</template>

<script>
import { defineComponent } from 'vue'

export default defineComponent({
  props: {
    statisticsData: Object
  },
  data() {
    return {
      myCharts: null
    }
  },
  watch: {
    statisticsData: {
      handler(val) {
        this.setChart();
      },
      deep: true
    }
  },
  methods: {
    setChart() {
      if (!this.myCharts) {
        this.myCharts = this.$echarts.init(this.$refs.statistics);
      }
      let statisticsData = this.statisticsData;
      if (!statisticsData || !statisticsData.length) {
        return;
      }

      let axisData = [];
      let seriesData = [];
      for (let index in statisticsData) {
        let range = statisticsData[index];
        axisData.push(range.label);
        seriesData.push(range.num)
      }

      this.myCharts.setOption({
        title: {
          text: '年龄统计',
          left: 'center'
        },
        tooltip: {},
        xAxis: {
          type: 'category',
          data: axisData
        },
        yAxis: {
          type: 'value'
        },
        series: [
          {
            data: seriesData,
            type: 'bar',
            showBackground: true,
            backgroundStyle: {
              color: 'rgba(180, 180, 180, 0.2)'
            }
          }
        ]
      })
    }
  }
})
</script>
